module.exports = __webpack_public_path__ + "img/impostor-footer.23c43eea.png";